import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Meta from '../components/Meta';
import './Projects.css';
import '../index.css';



// Project Images
import atbookImg from '../assets/projects/atbook-project1.png';
import bienebImg from '../assets/projects/bieneb-project.png';
import altajImg from '../assets/projects/altaj-project.png';

const projectsList = [
    {
        id: 'atbook',
        image: atbookImg,
        tags: ["Accounting", "GoBD", "Automation", "React"]
    },
    {
        id: 'bieneb',
        image: bienebImg,
        tags: ["SaaS", "Loyalty", "PWA", "QR-Code"]
    },
    {
        id: 'altaj',
        image: altajImg,
        tags: ["Web Design", "Healthcare", "UX/UI"]
    }
];

function Projects() {
    const { t } = useTranslation();

    return (
        <div className="projects-page">
            <Meta
                title={`${t('projects_page.title')} | Vorpoint`}
                description={t('projects_page.subtitle')}
            />

            <section className="modern-hero">
                <div className="hero-content">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        {t('projects_page.title')}
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        {t('projects_page.subtitle')}
                    </motion.p>
                </div>
            </section>

            <div className="container">
                <div className="projects-list">
                    {projectsList.map((config, index) => {
                        // Retrieve content from i18n
                        const content = t(`project_details.${config.id}`, { returnObjects: true });

                        return (
                            <motion.div
                                key={config.id}
                                className="project-row"
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.6, delay: index * 0.1 }}
                            >
                                <div className="project-image-container">
                                    <img src={config.image} alt={content.title} />
                                    <div className="project-category-badge">{content.category}</div>
                                </div>
                                <div className="project-info">
                                    <div className="project-tags">
                                        {config.tags.map((tag, i) => (
                                            <span key={i} className="project-tag">{tag}</span>
                                        ))}
                                    </div>
                                    <h2>{content.title}</h2>
                                    <p>{content.description}</p>
                                    <Link to={`/projekte/${config.id}`} className="project-link-btn">
                                        {t('projects_page.read_more')}
                                    </Link>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>

            <section className="final-cta-services">
                <div className="final-cta-content-services">
                    <h2>{t('projects_page.cta_title')}</h2>
                    <p>{t('projects_page.cta_text')}</p>
                    <Link to="/kontakt">
                        <button className="cta-button-services">
                            {t('projects_page.cta_button')}
                        </button>
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default Projects;


